THEME.page={
  init: function() {
    // jQuery('.tabs').find('div').first().show();
    jQuery('.tabs').find('ul li')
      .on('click', function() {
        jQuery('.tabs > div').hide();
        jQuery('.tabs').find('ul li').removeClass('active');
        if (jQuery(this).hasClass('first_tab')) {
          jQuery('.first_tab_div').show();
          jQuery(this).addClass('active');
        } else if (jQuery(this).hasClass('last_tab')) {
          jQuery('.last_tab_div').show();
          jQuery(this).addClass('active');
        }
      });
    // .first().addClass('active');
  }
};
